@if (packages()?.steps?.length) {
	<!-- JAW HEADER -->
	<div class="col jaw-header-col">
		<div class="vertical-spacer"></div>
		@for (jaw of jaws; track jaw) {
			<div class="jaw barlow-condensed">{{ jaw | translate }}</div>
		}
	</div>
	<!-- PACKAGES -->
	<div class="col" data-cy="packages-col">
		<h2>{{ "Behandlungspaket" | translate }}</h2>
		@for (jaw of jaws; track jaw) {
			<div>
				@if (packages()?.steps?.length) {
					@for (pkg of packages()?.steps; track $index) {
						<div [ngClass]="{ delivered: noOfOrders > $index }" class="package">
							{{ "Paket" | translate }} <span>{{ $index + 1 }}</span> ({{ pkg }})
						</div>
					}
				} @else {
					<div class="package">
						{{ "Paket" | translate }} <span>1</span>
						(?)
					</div>
				}
			</div>
		}
	</div>
	<!-- FREE CORRECTIONS -->
	@if (packages()?.freeCorrections?.length) {
		<div class="col" data-cy="free-corrections-col">
			<h2>{{ "Refinements" | translate }}</h2>
			@for (jaw of jaws; track jaw) {
				<div>
					@if (packages()?.freeCorrections?.length < 4) {
						@for (pkg of packages()?.freeCorrections; track $index) {
							<div
								[ngClass]="{
									delivered: noOfOrders > $index + packages()?.steps.length
								}"
								class="package"
							>
								{{ "Paket" | translate }}
								<span>{{ $index + packages()?.steps.length + 1 }}</span> ({{ pkg }})
							</div>
						}
					} @else {
						<div
							[ngClass]="{
								delivered: noOfOrders >= firstShownCorrection + noPkgs
							}"
							class="package"
						>
							@if (prefix) {
								<span>...</span>
							}
							{{ "Paket" | translate }} {{ noPkgs + firstShownCorrection }}
						</div>
						<div
							[ngClass]="{
								delivered: noOfOrders >= firstShownCorrection + noPkgs + 1
							}"
							class="package"
						>
							{{ "Paket" | translate }} {{ noPkgs + firstShownCorrection + 1 }}
						</div>
						<div class="package">
							{{ "Paket" | translate }} {{ noPkgs + firstShownCorrection + 2 }}
							@if (suffix) {
								<span>...</span>
							}
						</div>
					}
				</div>
			}
		</div>
	}
	<!-- CHARGEABLE REFINEMENTS -->
	@if (packages()?.addCorrections?.length || packages()?.chargeableRefinements?.length) {
	<div class="col block" data-cy="add-corrections-col">
		<h2>{{ "Chargeable refinements" | translate }}</h2>
		<div class="chargeable-refinements-packages" [ngStyle]="{'--numJaws': jaws.length}">
			<!-- PRE 3.2.0 -->
			@if(packages()?.addCorrections?.length){
			<div>
				@for (pkg of packages()?.addCorrections; track $index) {
				<div [ngClass]="{ delivered: isRefinementPackageDelivered($index, false)}"
					class="package">
					{{ "Paket" | translate }}
					<span>{{ getRefinementPackageNumber($index, false) }}</span> ({{ pkg }})
				</div>
				}
			</div>
			}
			<!-- POST 3.2.0 -->
			@if(packages()?.chargeableRefinements?.length){
			<div>
				@for (jaw of jaws; track jaw) {
				<div>
					@if(jaws.includes('uj') && jaw === 'uj') {
					@for (pkg of packages()?.chargeableRefinements; track $index) {
					<div [ngClass]="{ delivered: isRefinementPackageDelivered($index, true)}" class="package">
						{{ "Paket" | translate }} <span>{{ getRefinementPackageNumber($index, true) }}</span> ({{ pkg.uj }})
					</div>
					}
					}
					@if(jaws.includes('lj') && jaw === 'lj') {
					@for (pkg of packages()?.chargeableRefinements; track $index) {
					<div [ngClass]="{ delivered: isRefinementPackageDelivered($index, true)}" class="package">
						{{ "Paket" | translate }} <span>{{ getRefinementPackageNumber($index, true) }}</span> ({{ pkg.lj }})
					</div>
					}
					}
				</div>
				}
			</div>
			}
		</div>
	</div>
	}
}
